import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import ImpactHero, { heroImgStyles } from '~components/ImpactHero';
import Infographic from '~components/Infographic';

// Page Navigation
import PageNav from '~components/PageNav';
import BoardCard from '~components/PageCard/BoardCard';
import AdvocacyCard from '~components/PageCard/AdvocacyCard';

import Pills from '~components/Svg/Pills';
import TestTube from '~components/Svg/TestTube';
import GlobeBadge from '~components/Svg/GlobeBadge';
import ResearchFolder from '~components/Svg/ResearchFolder';
import MoneyPot from '~components/Svg/MoneyPot';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Recherche" desc="Description" />
      <ImpactHero title="Recherche">
        <StaticImage style={heroImgStyles} src="../../images/research.jpg" alt="" />
      </ImpactHero>
      <div tw="container">
        <div tw="grid gap-12 items-end md:(gap-24 grid-cols-2)">
          <Infographic icon={<TestTube tw="text-blue h-36 w-auto" />} title="32">
          Projets et essais cliniques de pointe soutenus au Canada
          </Infographic>
          <Infographic icon={<GlobeBadge tw="text-blue h-36 w-auto" />} title="19">
          Portée de 19 pays du portefeuille de recherche internationale 2020 de FRDJ
          </Infographic>
        </div>
      </div>
      <div tw="my-12 py-12 bg-blue text-white">
        <div tw="container">
          <div tw="grid gap-12 my-12 items-end md:(gap-24 grid-cols-2)">
            <Infographic icon={<ResearchFolder tw="text-white h-36 w-auto" />} title="60+">
            Plus de 60 essais cliniques soutenus au Canada et dans le monde pour commercialiser plus rapidement de nouveaux traitements
            </Infographic>
            <Infographic icon={<MoneyPot tw="text-white h-36 w-auto" />} title="100+">
            Plus de 100 nouvelles subventions de recherche pour les études les plus prometteuses au monde
            </Infographic>
          </div>
        </div>
      </div>
      <div tw="container">
        <Infographic icon={<Pills tw="text-blue h-36 w-auto" />} title="85,000,000 + $">
        L’équivalent de 85 000 000 $ CA en dollars des donateurs de FRDJ investis dans la recherche sur le DT1 dans le monde entier
        </Infographic>
        <PageNav previous={<BoardCard />} next={<AdvocacyCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
